import Vue from 'vue';

Vue.component('ranking-table-component', {
    /**
     * Vue.js instance reactive data variables.
     *
     * @return {Object}
     */
    data() {
        return {
        };
    },

    /**
     * Called when the Vue.js instance is mounted and
     * ready for use.
     *
     * @return {void}
     */
    mounted() {
        const table = this.$refs.ranking;

        if (!table) {
            return;
        }

        const tbody = table.querySelector('tbody');
        const rows = tbody.querySelectorAll('tr');
        const current = table.querySelector('.active');
        const position = [].indexOf.call(rows, current) + 1;
        const next = current.nextElementSibling;

        if (position === 1) {
            const postion2 = current.nextElementSibling;
            const postion3 = postion2.nextElementSibling;
            const postion4 = postion3.nextElementSibling;
            const postion5 = postion4.nextElementSibling;

            const visibleRows = [current, postion2, postion3, postion4, postion5];

            visibleRows.forEach((row) => {
                row.classList.add('mobile-visible');
            });
        } else if (position === 2) {
            const postion1 = current.previousElementSibling;
            const postion3 = current.nextElementSibling;
            const postion4 = postion3.nextElementSibling;
            const postion5 = postion4.nextElementSibling;

            const visibleRows = [current, postion1, postion3, postion4, postion5];

            visibleRows.forEach((row) => {
                row.classList.add('mobile-visible');
            });
        } else if (position === 17) {
            const postion18 = current.nextElementSibling;
            const postion16 = current.previousElementSibling;
            const postion15 = postion16.previousElementSibling;
            const postion14 = postion15.previousElementSibling;

            const visibleRows = [current, postion18, postion16, postion15, postion14];

            visibleRows.forEach((row) => {
                row.classList.add('mobile-visible');
            });
        } else if (position === 18 || next === null) {
            const postion17 = current.previousElementSibling;
            const postion16 = postion17.previousElementSibling;
            const postion15 = postion16.previousElementSibling;
            const postion14 = postion15.previousElementSibling;

            const visibleRows = [current, postion17, postion16, postion15, postion14];

            visibleRows.forEach((row) => {
                row.classList.add('mobile-visible');
            });
        } else if (position > 2 || position < 17) {
            const before = current.previousElementSibling;
            const secondBefore = before.previousElementSibling;
            const after = current.nextElementSibling;
            const secondAfter = after.nextElementSibling;

            const visibleRows = [current, before, secondBefore, after, secondAfter];

            visibleRows.forEach((row) => {
                row.classList.add('mobile-visible');
            });
        }
    },

    /**
     * Vue.js instance methods.
     *
     * @type {Object}
     */
    methods: {

    },
});
